import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { Modal, Field } from "./Rooms";
import { Plus } from "lucide-react";
import { formatDate } from "@/lib/format";
import { toast } from "sonner";

export default function Properties() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);

    const load = async () => { const { data } = await api.get("/properties"); setItems(data); };
    useEffect(() => { load(); }, []);

    return (
        <>
            <Topbar
                title="Properties"
                subtitle={`${items.length} properties`}
                actions={<button onClick={() => setOpen(true)} className="akm-btn-primary" data-testid="new-property-btn"><Plus size={14} /> Add property</button>}
            />
            <div className="flex-1 overflow-auto p-6">
                <div className="akm-card overflow-hidden">
                    <table className="akm-table w-full">
                        <thead className="bg-muted/40">
                            <tr><th>Name</th><th>Address</th><th>City</th><th>Country</th><th>Currency</th><th>Timezone</th><th>Added</th></tr>
                        </thead>
                        <tbody>
                            {items.map((p) => (
                                <tr key={p.id}>
                                    <td className="font-medium">{p.name}</td>
                                    <td className="text-muted-foreground">{p.address || "—"}</td>
                                    <td>{p.city || "—"}</td>
                                    <td>{p.country || "—"}</td>
                                    <td><span className="font-mono text-[12px]">{p.currency}</span></td>
                                    <td className="text-muted-foreground">{p.timezone}</td>
                                    <td className="text-muted-foreground">{formatDate(p.created_at)}</td>
                                </tr>
                            ))}
                            {items.length === 0 && <tr><td colSpan="7" className="py-12 text-center text-muted-foreground">No properties yet</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
            {open && <PropertyForm onClose={() => setOpen(false)} onSaved={async () => { setOpen(false); await load(); }} />}
        </>
    );
}

function PropertyForm({ onClose, onSaved }) {
    const [form, setForm] = useState({ name: "", address: "", city: "", country: "", timezone: "Europe/Tirane", currency: "EUR" });
    const [saving, setSaving] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try { await api.post("/properties", form); toast.success("Property created"); onSaved(); }
        catch (e2) { toast.error(formatApiErrorDetail(e2.response?.data?.detail)); }
        finally { setSaving(false); }
    };
    return (
        <Modal title="Add property" onClose={onClose}>
            <form onSubmit={submit} className="space-y-3">
                <Field label="Name"><input className="akm-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
                <Field label="Address"><input className="akm-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Field>
                <div className="grid grid-cols-2 gap-2">
                    <Field label="City"><input className="akm-input" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></Field>
                    <Field label="Country"><input className="akm-input" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} /></Field>
                </div>
                <div className="grid grid-cols-2 gap-2">
                    <Field label="Timezone"><input className="akm-input" value={form.timezone} onChange={(e) => setForm({ ...form, timezone: e.target.value })} /></Field>
                    <Field label="Currency"><input className="akm-input" value={form.currency} onChange={(e) => setForm({ ...form, currency: e.target.value })} /></Field>
                </div>
                <div className="flex justify-end gap-2 pt-2">
                    <button type="button" onClick={onClose} className="akm-btn-ghost">Cancel</button>
                    <button type="submit" disabled={saving} className="akm-btn-primary">{saving ? "Saving…" : "Create"}</button>
                </div>
            </form>
        </Modal>
    );
}
